import { jobsPerPage, revalidate } from "../../../common/constants";
import { JobListing } from "../../../common/types";
import Poslovi from "../../../view/screens/Poslovi/Poslovi";
import { getAllJobsPerTag, handleGetJobsCount } from "../../api/job/get";
import { handleGetActiveTags } from "../../api/tags/get";

interface staticParams {
    params: {
        tag: string;
        page: string;
    };
}

interface tagsProps {
    jobs: JobListing[];
    name: string;
    page: number;
    total: number;
}

export default function Pocetna({ jobs, total, name, page }: tagsProps) {
    return (
        <Poslovi name={name} type="tag" jobs={jobs} total={total} page={page} />
    );
}

export async function getStaticPaths() {
    const tags = await handleGetActiveTags();
    const paths = [];

    for (const tag of tags) {
        const jobsTotal = await handleGetJobsCount({
            jobs_tags: {
                some: {
                    tags: {
                        slug: tag.value,
                    },
                },
            },
        });

        const numOfPages = Math.ceil(jobsTotal / jobsPerPage);

        const tagPath = Array.from(Array(numOfPages).keys()).map((k) => ({
            params: { tag: tag.value, page: (k + 1).toString() },
        }));

        paths.push(tagPath);
    }

    const formattedPaths = paths.flat().slice(0, 20);

    return {
        paths: formattedPaths,
        fallback: "blocking",
    };
}

export async function getStaticProps({ params }: staticParams) {
    const { tag, page } = params;

    const intPage = parseInt(page, 10);

    const response = await getAllJobsPerTag({
        tag: tag,
        perPage: jobsPerPage,
        page: intPage,
    });

    if (response.data) {
        return {
            props: {
                jobs: response.data,
                total: response.count,
                name: tag,
                page: intPage,
            },
            revalidate: revalidate,
        };
    }
    if (!response.data) {
        return {
            notFound: true,
            revalidate: revalidate,
        };
    }
}
